/**************************************
 ** AtlasImageCache
 *
 *  Implements the storage of images for an Atlas sphere.  These are indexed by the lat/long key (e.g, B01).
 *  Each entry in the cache also contains a resolution, higher resolutions (greater in number) will overwrite
 *  lower resolutions and replace the available image at that cache location.
 *
 *  Keys - an array of the available keys in the cache
 *  Cache - the structure that holds the Images
 *  Bitmaps - the structure that contains the loaded Bitmaps
 *  Subscribers - the callbacks that should be called when an image loads
 ***************************************/
define('atlas/AtlasImageCache', [], function() {
    'use strict';

    var AtlasImageCache = function() {
        this._keys = [];
        this._cache = {};
        this._bitmaps = {};
        this._indexResolutionSubscribers = {};
        this._resolutionSubscribers = {};
        this.RESOLUTIONS = {
            '300'  : 1,
            '600'  : 2,
            '2k'   : 3,
            '2000' : 3,
            '2048' : 3,
            'other': 4
        };
    };

    AtlasImageCache.prototype.store = function(image) {
        var cachedImage = this.fetch(image.index);

        if (!cachedImage) {
            this._keys.push(image.index);
            this._cache[image.index] = image;
            cachedImage = image;
        }
        else {
            var cachedResolution = this.RESOLUTIONS[cachedImage.resolution] || this.RESOLUTIONS.other;
            var imageResolution = this.RESOLUTIONS[image.resolution] || this.RESOLUTIONS.other;

            //store the higher resolution
            if (imageResolution > cachedResolution) {
                this._cache[image.index] = image;
                cachedImage = image;
            }
            else {
                //nothing to overwrite, unsure about whether to notify or not - going to return for now
                return;
            }
        }

        if (this._indexResolutionSubscribers[image.index] && this._indexResolutionSubscribers[image.index][image.resolution]) {
            for (var s = 0; s < this._indexResolutionSubscribers[image.index][image.resolution].length; ++s) {
                //perform the callbacks
                this._indexResolutionSubscribers[image.index][image.resolution][s](image);
            }
        }
        if (this._resolutionSubscribers[image.resolution]) {
            for (var s = 0; s < this._resolutionSubscribers[image.resolution].length; ++s) {
                //perform the callbacks
                this._resolutionSubscribers[image.resolution][s](image);
            }
        }
    };

    AtlasImageCache.prototype.fetch = function(index) {
        if (!this._cache[index]) {
            return null;
        }
        return this._cache[index];
    };

    AtlasImageCache.prototype.subscribeToIndexAndResolution = function(index, resolution, callback) {
        if (!this._indexResolutionSubscribers[index]) {
            this._indexResolutionSubscribers[index] = [];
        }
        if (!this._indexResolutionSubscribers[index][resolution]) {
            this._indexResolutionSubscribers[index][resolution] = [];
        }
        this._indexResolutionSubscribers[index][resolution].push(callback);
    };

    AtlasImageCache.prototype.subscribeToResolution = function(resolution, callback) {
        if (!this._resolutionSubscribers[resolution]) {
            this._resolutionSubscribers[resolution] = [];
        }
        this._resolutionSubscribers[resolution].push(callback);
    };

    AtlasImageCache.prototype.printCache = function() {
        //no-op
    };

    return AtlasImageCache;
});
